module.exports = __webpack_public_path__ + "kunsurukoskettaa-9e83dd2a6ba06c2520ac.jpg";